const routes = [
  {
    // 路由的重定向
    path: '/',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/home',
    name: 'home',
    components: {
      // header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/home/content')
    }
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/login/content')
    }
  },
  {
    path: '/import',
    redirect: {
      name: 'importlist'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/importassistant/content')
    },
    // 二级路由
    children: [
      {
        path: '/importassistant/importlist',
        name: 'importlist',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/importassistant/importList')
        }
      }
    ]
  },
  {
    path: '/basicdata',
    redirect: {
      name: 'domainset'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/basicdata/content')
    },
    // 二级路由
    children: [
      {
        path: '/basicdata/domainsetting',
        name: 'domainset',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/DomainSetting')
        },
        children: [
          {
            path: '/basicdata/domainsetting/addorg',
            name: 'addorg',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddOrg')
            }
          },
          {
            path: '/basicdata/domainsetting/addstore',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddStore')
            }
          }
        ]
      },
      {
        path: '/basicdata/rolesetting',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/RoleSetting')
        },
        children: [
          {
            path: '/basicdata/rolesetting/addrole',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddRole')
            }
          },
          {
            path: '/basicdata/rolesetting/updateroleauthority',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/UpdateRoleAuthority')
            }
          }
        ]
      },
      {
        path: '/basicdata/personnelmanagement',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/personnelmanagement')
        },
        children: [
          {
            path: '/basicdata/personnelmanagement/position',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/position')
            }
          },
          {
            path: '/basicdata/personnelmanagement/addperson',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddPerson')
            }
          }
        ]
      },
      {
        path: '/basicdata/tagmanagement',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/tagManagement')
        },
        children: [
          {
            path: '/basicdata/tagmanagement/addpersontag',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddPersonTag')
            }
          },
          {
            path: '/basicdata/tagmanagement/addstoretag',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddStoreTag')
            }
          },
          {
            path: '/basicdata/tagmanagement/personbindrole',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/personBindRole')
            }
          },
          {
            path: '/basicdata/tagmanagement/aboutperson',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/personTagAboutPerson')
            }
          },
          {
            path: '/basicdata/tagmanagement/aboutstore',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/personTagAboutStore')
            }
          }
        ]
      },
      {
        path: '/basicdata/orgtype',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/orgType')
        },
        children: [
          {
            path: '/basicdata/orgtype/addorgtype',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/AddOrgType')
            }
          }
        ]
      },
      {
        path: '/basicdata/costumerRelation',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/CostumerRelation')
        },
        children: [
          {
            path: '/basicdata/EditCostumerRelation',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/EditCostumerRelation')
            }
          }
        ]
      },
      {
        path: '/basicdata/fieldmanagement',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/basicdata/FieldManagement')
        }
      }
    ]
  },
  {
    path: '/companyallocation',
    redirect: {
      name: 'basicconfig'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/companyallocation/content')
    },
    // 二级路由
    children: [
      {
        path: '/companyallocation/basicconfig',
        name: 'basicconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/basicconfig')
        }
      },
      {
        path: '/companyallocation/basicinfo',
        name: 'basicinfo',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/basicinfo')
        }
      },
      {
        path: '/companyallocation/shoptempleteconfig',
        name: 'shoptempleteconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/shoptempleteconfig')
        }
      },
      {
        path: '/companyallocation/storefieldconfig',
        name: 'storefieldconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/storefieldconfig')
        }
      },
      {
        path: '/companyallocation/mntmoduleconfig',
        name: 'mntmoduleconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/mntmoduleconfig')
        }
      },
      {
        path: '/companyallocation/propmoduleconfig',
        name: 'propmoduleconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/propmoduleconfig')
        }
      },
      {
        path: '/companyallocation/mailconfig',
        name: 'mailconfig',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/companyallocation/mailconfig')
        }
      }
    ]
  },
  {
    path: '/storeinformation',
    redirect: {
      name: 'storemanage'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/storeinformation/content')
    },
    // 二级路由
    children: [
      {
        path: '/storeinformation/storemanagement',
        name: 'storemanage',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/StoreManagement')
        },
        children: [
          {
            path: '/storeinformation/storemanagement/addstore',
            name: 'AddStore',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/AddStore')
            }
          },
          {
            path: '/storeinformation/storemanagement/addtag',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/AddTag')
            }
          },
          {
            path: '/storeinformation/storemanagement/upload',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/upLoadAttachment')
            }
          }
        ]
      },
      {
        path: '/storeinformation/storetype',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/storeType')
        },
        children: [
          {
            path: '/storeinformation/storetype/addstoretype',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/AddStoreType')
            }
          }
        ]
      },
      {
        path: '/storeinformation/brandsetting',
        name: 'brandsetting',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/BrandSetting')
        },
        children: [
          {
            path: '/storeinformation/brandsetting/addbrand',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/AddBrand')
            }
          }
        ]
      },
      {
        path: '/storeinformation/areasetting',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/AreaSetting')
        }
      },
      {
        path: '/storeinformation/areasetting/editareainfo',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storeinformation/EditAreaInfo')
        }
      }
    ]
  },
  {
    path: '/devicemanagement',
    redirect: {
      name: 'mechanicalarm'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/devicemanagement/content')
    },
    // 二级路由
    children: [
      {
        path: '/devicemanagement/mechanicalarm',
        name: 'mechanicalarm',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/devicemanagement/mechanicalarm')
        },
        children: [
          {
            path: '/devicemanagement/mechanicalarm/updatamechanicalarm',
            name: 'UpdataMechanicalarm',
            components: {
              default: () => import(/* webpackChunkName: "group-main" */ '@/layout/devicemanagement/updatamechanicalarm')
            }
          }
        ]
      },
      {
        path: '/devicemanagement/smartscreen',
        name: 'smartscreen',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/devicemanagement/smartscreen')
        }
      }
    ]
  },
  {
    path: '/storemnt/',
    redirect: {
      name: 'storeMnt'
    },
    components: {
      header: () => import(/* webpackChunkName: "group-main" */ '@/pages/header'),
      sideBar: () => import(/* webpackChunkName: "group-main" */ '@/pages/sideBar'),
      default: () => import(/* webpackChunkName: "group-main" */ '@/pages/storemnt/content')
    },
    children: [
      {
        path: '/storemnt/mntcategory',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/MntCategory')
        },
        children: [{
          path: '/storemnt/mntcategory/editmntcategory',
          components: {
            default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/EditMntCategory')
          }
        }]
      }, {
        path: '/storemnt/propcategory',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/PropCategory')
        },
        children: [{
          path: '/storemnt/propcategory/editpropcategory',
          name: 'editpropcategory',
          components: {
            default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/EditPropCategory')
          }
        }]
      }, {
        path: '/storemnt/mntquestion',
        name: 'mntQuestion',
        components: {
          default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/MntQuestion')
        },
        children: [{
          path: '/storemnt/mntquestion/editmntquestion',
          name: 'editmntquestion',
          components: {
            default: () => import(/* webpackChunkName: "group-main" */ '@/layout/storemnt/EditMntQuestion')
          }
        }]
      }
    ]
  }
]

export default routes
